import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const getTokenFromUrl = () => {
	const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
	const queryParams = new URLSearchParams(window.location.search);
	return (
		hashParams.get("mobile_view") ||
		queryParams.get("mobile_view") ||
		hashParams.get("token") ||
		queryParams.get("token")
	);
};

export default function AppAuthRedirect() {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const token = getTokenFromUrl();

		if (
			!token ||
			location.pathname === "/auth/app" ||
			location.pathname === "/resetpassword" ||
			location.pathname === "/reset-password"
		) {
			return;
		}

		const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.delete("mobile_view");
		queryParams.delete("token");
		const search = queryParams.toString();
		const redirect =
			hashParams.get("redirect") ||
			queryParams.get("redirect") ||
			`${location.pathname}${search ? `?${search}` : ""}`;

		console.log("[AppAuthRedirect] token u gjet jashte /auth/app, ridrejtoj...", {
			from: location.pathname,
			redirect,
		});

		navigate(
			`/auth/app#token=${encodeURIComponent(token)}&redirect=${encodeURIComponent(redirect)}`,
			{ replace: true }
		);
	}, [location.pathname, location.hash, location.search, navigate]);

	return null;
}
